import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Navbar } from '../components/Navbar';
import { Region } from '../types/models';
import { AlertCircle, CheckCircle2 } from 'lucide-react';
export const SignupPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [cellNumber, setCellNumber] = useState('');
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [region, setRegion] = useState<'limpopo' | 'gauteng'>('gauteng');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const {
    signup
  } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signup(name, surname, email, password, region, cellNumber, whatsappNumber);
      // Redirect to home page after successful signup
      navigate('/');
    } catch (err: any) {
      setError(err.message || 'Signup failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  return <div className="min-h-screen bg-rose-50/30" data-id="element-2917">
      <Navbar data-id="element-2918" />

      <div className="pt-24 pb-12 px-4 sm:px-6 lg:px-8 min-h-[calc(100vh-80px)] flex items-center justify-center" data-id="element-2919">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white p-8 rounded-2xl shadow-xl max-w-md w-full" data-id="element-2920">
          <div className="text-center mb-8" data-id="element-2921">
            <h1 className="text-3xl font-serif font-bold text-gray-900 mb-2" data-id="element-2922">
              Create Account
            </h1>
            <p className="text-gray-600" data-id="element-2923">Join Bloom & Pop today</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5" data-id="element-2924">
            {error && <motion.div initial={{
            opacity: 0,
            y: -10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="flex items-start gap-2 p-3 rounded-lg bg-red-50 text-red-600 text-sm font-medium" data-id="element-2925">
                <AlertCircle className="w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-2926" />
                <span data-id="element-2927">{error}</span>
              </motion.div>}

            <div className="grid grid-cols-2 gap-4" data-id="element-2928">
              <Input label="First Name" type="text" value={name} onChange={e => setName(e.target.value)} required placeholder="John" data-id="element-2929" />
              <Input label="Last Name" type="text" value={surname} onChange={e => setSurname(e.target.value)} required placeholder="Doe" data-id="element-2930" />
            </div>

            <Input label="Email Address" type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="you@example.com" data-id="element-2931" />

            <Input label="Cell Phone Number" type="tel" value={cellNumber} onChange={e => setCellNumber(e.target.value)} placeholder="+27 82 345 6789" data-id="element-2932" />

            <Input label="WhatsApp Number (Optional)" type="tel" value={whatsappNumber} onChange={e => setWhatsappNumber(e.target.value)} placeholder="+27 82 345 6789" data-id="element-2933" />

            <div data-id="element-2934">
              <Input label="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="••••••••" data-id="element-2935" />
              <p className="text-xs text-gray-500 mt-1" data-id="element-2936">
                Must be at least 6 characters long
              </p>
            </div>

            {/* Region Selector */}
            <div data-id="element-2937">
              <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-2938">
                Select Your Region
              </label>
              <div className="grid grid-cols-2 gap-4" data-id="element-2939">
                <button type="button" onClick={() => setRegion('limpopo')} className={`p-4 border-2 rounded-lg transition-all ${region === 'limpopo' ? 'border-rose-500 bg-rose-50 shadow-sm' : 'border-gray-300 hover:border-gray-400'}`} data-id="element-2940">
                  <div className="font-semibold text-gray-900" data-id="element-2941">Limpopo</div>
                  {region === 'limpopo' && <CheckCircle2 className="w-5 h-5 text-rose-500 mx-auto mt-2" data-id="element-2942" />}
                </button>
                <button type="button" onClick={() => setRegion('gauteng')} className={`p-4 border-2 rounded-lg transition-all ${region === 'gauteng' ? 'border-rose-500 bg-rose-50 shadow-sm' : 'border-gray-300 hover:border-gray-400'}`} data-id="element-2943">
                  <div className="font-semibold text-gray-900" data-id="element-2944">Gauteng</div>
                  {region === 'gauteng' && <CheckCircle2 className="w-5 h-5 text-rose-500 mx-auto mt-2" data-id="element-2945" />}
                </button>
              </div>
            </div>

            <Button type="submit" className="w-full" disabled={loading} data-id="element-2946">
              {loading ? 'Creating account...' : 'Create Account'}
            </Button>

            <div className="text-center" data-id="element-2947">
              <p className="text-sm text-gray-600" data-id="element-2948">
                Already have an account?{' '}
                <Link to="/login" className="font-medium text-rose-600 hover:text-rose-500" data-id="element-2949">
                  Log in
                </Link>
              </p>
            </div>
          </form>
        </motion.div>
      </div>
    </div>;
};